import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class InstituteScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
                        locationOptions: [], 
                        currentInstitute: {id: null, 
                                        name: "", 
                                        mail: "", 
                                        address: "", 
                                        phone: "",
                                        contact_person: "", 
                                        locationid: "",
                                        location: ""}, 
                        validation: {
                            isValid: true,
                            name: true,
                            location: true
                        }
                    };

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeAddress = this.handleChangeAddress.bind(this); 
        this.handleChangeMail = this.handleChangeMail.bind(this);  
        this.handleChangePerson = this.handleChangePerson.bind(this);  
        this.handleChangePhone = this.handleChangePhone.bind(this);   
        this.handleChangeLocation = this.handleChangeLocation.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.institute && this.props.args.institute.length > 0) {
            BaseApi.get("/institution", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {id: this.props.args.institute}, withCredentials: true})
            .then(res => {
                this.setState({currentInstitute: res.data})
            })    
            .catch()
        } else {
            this.validate()
        }

        BaseApi.get("/locations", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {name: ""}, withCredentials: true})
        .then(res => {
            const locationOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({locationOptions: locationOptions})
        })    
        .catch()
    }

    async componentDidUpdate(prevProps, prevState) {
        
        if (this.state.currentInstitute != prevState.currentInstitute) {
            this.validate()
        } 
    }    

    validate() {
        const name = this.state.currentInstitute.name.length > 0
        const location = this.state.currentInstitute.location.length > 0
        this.setState( {
            validation: {
                isValid: name && location,
                name: name,
                location: location
            }
        })

    }

    save(event) {
        BaseApi.post('/institution', this.state.currentInstitute, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                name: event.target.value
            }
        }))
    }

    handleChangeAddress(event) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                address: event.target.value
            }
        }))
    }

    handleChangeMail(event) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                mail: event.target.value
            }
        }))
    }

    handleChangePerson(event) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                contact_person: event.target.value
            }
        }))
    }
    
    handleChangePhone(event) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                phone: event.target.value
            }
        }))
    }

    handleChangeLocation(selectedOption) {
        this.setState(prevState => ({
            currentInstitute: {
                ...prevState.currentInstitute,
                locationid: selectedOption.value,
                location: selectedOption.label
            }
        }))
    }

    openBeneficiaries() {
        this.props.navigate("beneficiaries",    
        {caller: "institute", callargs: this.props.args, instituteid: this.state.currentInstitute.id})
    }


    openEvents() {
        this.props.navigate("events", 
        {caller: "institute", callargs: this.props.args, instituteid: this.state.currentInstitute.id})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "institute", callargs: this.props.args, refrecid: this.state.currentInstitute.id})    
    }

    render() {
        
        const instituteExists = !!this.state.currentInstitute.id;
        
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Учреждение"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {instituteExists? "Редактирование учреждения" : "Новое учреждение"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label 
                                            for="name"
                                            className={`form-label ${this.state.validation.name ? "" : "text-danger"}`}
                                        >
                                            Наименование:
                                        </label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.state.validation.name ? "" : "text-danger"}`}
                                            id="name" 
                                            value={this.state.currentInstitute.name} 
                                            onChange={this.handleChangeName} 
                                        />
                                        <label for="address">Адрес:</label>
                                        <input type="text" class="form-control" id="address"  value={this.state.currentInstitute.address} onChange={this.handleChangeAddress} />
                                        <label for="phone">Телефон:</label>
                                        <input type="text" class="form-control" id="phone"  value={this.state.currentInstitute.phone} onChange={this.handleChangePhone} />
                                        <label for="mail">Email:</label>
                                        <input type="text" class="form-control" id="mail"  value={this.state.currentInstitute.mail} onChange={this.handleChangeMail} />
                                        <label for="person">Контактное лицо:</label>
                                        <input type="text" class="form-control" id="person"  value={this.state.currentInstitute.contact_person} onChange={this.handleChangePerson} />
                                        <label 
                                            for="localion"
                                            className={`form-label ${this.state.validation.location ? "" : "text-danger"}`}
                                        >
                                            Населенный пункт:
                                        </label>
                                        <div
                                            className={
                                                this.state.validation.location
                                                ? "" : "border border-danger rounded"
                                            }
                                        >
                                            <Select options= {this.state.locationOptions} 
                                                    id="location" 
                                                    onChange={this.handleChangeLocation}
                                                    placeholder={this.state.currentInstitute.location}    
                                            />
                                        </div>
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button 
                                                    class="btn btn-primary w-100" 
                                                    onClick={this.save}
                                                    disabled = {!this.state.validation.isValid}
                                                >
                                                    Сохранить
                                                </button>   
                                            </div>
                                        </div>        
                                    </div>
                                
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <h6 className="card-title mb-3">Действия</h6>
                        {instituteExists && (
                            <div>
                                <button 
                                    className="btn btn-outline-primary w-100 mb-2" 
                                    onClick={()=>{this.openBeneficiaries()}}
                                >
                                    Участники
                                </button>   
                                <button 
                                    className="btn btn-outline-primary w-100 mb-2" 
                                    onClick={()=>{this.openEvents()}}
                                >
                                    События
                                </button>  
                    
                                <button 
                                    className="btn btn-outline-primary w-100 mb-2"  
                                    onClick={()=>{this.openRefs()}}
                                >
                                    Ссылки
                                </button>   
                       
                            </div>    
                        )}
                        {!instituteExists && (
                            <p className="text-muted mb-0">
                                Дополнительные действия станут доступны после сохранения записи.
                            </p>
                        )}
                    </div>
                </div>

                {/*         
                <div class="row mt-5">
                    <div class="col-md-6 float-left">
                        <form>
                            <div class="form-group">
                                <label for="name">Наименование:</label>
                                <input type="text" class="form-control" id="name" value={this.state.currentInstitute.name} onChange={this.handleChangeName} />
                                <label for="address">Адрес:</label>
                                <input type="text" class="form-control" id="address"  value={this.state.currentInstitute.address} onChange={this.handleChangeAddress} />
                                <label for="phone">Телефон:</label>
                                <input type="text" class="form-control" id="phone"  value={this.state.currentInstitute.phone} onChange={this.handleChangePhone} />
                                <label for="mail">Email:</label>
                                <input type="text" class="form-control" id="mail"  value={this.state.currentInstitute.mail} onChange={this.handleChangeMail} />
                                <label for="person">Контактное лицо:</label>
                                <input type="text" class="form-control" id="person"  value={this.state.currentInstitute.contact_person} onChange={this.handleChangePerson} />
                                <label for="localion">Локация:</label>
                                <Select options= {this.state.locationOptions} 
                                        id="location" 
                                        onChange={this.handleChangeLocation}
                                        placeholder={this.state.currentInstitute.location}    
                                        />
                            </div>
                            
                        </form>
                    </div>
                    <div class="col-md-3 offset-3"> 
                        {this.state.currentInstitute.id && 
                        <div  class="row">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openBeneficiaries()}}>Участники</button>   
                        </div>
                        }
                        {this.state.currentInstitute.id && 
                        <div class="row mt-1">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openEvents()}}>События</button>  
                        </div>
                        }
                        {this.state.currentInstitute.id && 
                        <div class="row mt-1">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openRefs()}}>Ссылки</button>   
                        </div>
                        }
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>
                        </div>
                    </div>
                </div>
                */}
               
            </div>
            
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/institute.js